/**
 * AdminPage - Administrative functions and system tools
 * Available to all authenticated users
 */
import React from 'react';
import { MockFeedbackSection } from '../organisms/MockFeedbackSection';

const AdminPage: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">
          🔧 Admin Panel
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Administrative functions and system tools for managing the feedback system.
        </p>
      </div>

      <div className="space-y-6">
        {/* Mock Feedback Testing Section */}
        <MockFeedbackSection />
        
        {/* Future admin sections can be added here */}
        <div className="bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
            🚧 Future Admin Features
          </h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Additional development and administrative tools will be added here as needed.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminPage;